import request from '@/utils/request'
// 模板列表
export function skillListData(data) {
  return request({
    url: '/sys/skill/list',
    method: 'post',
    data
  })
}
// 模板删除
export function skillDelete(data) {
  return request({
    url: '/sys/skill/delete',
    method: 'post',
    data
  })
}
// 查看详情
export function skillInfoData(id) {
  return request({
    url: `/sys/skill/info/${id}`,
    method: 'get'
  })
}
// 模板添加
export function skillSaveData(data) {
  return request({
    url: '/sys/skill/save',
    method: 'post',
    data
  })
}
// 模板修改
export function skillUpdateData(data) {
  return request({
    url: '/sys/skill/update',
    method: 'post',
    data
  })
}